import { PropsWithChildren } from "react"

export const Container = ({ children, maxW = 1170 }: PropsWithChildren & { maxW?: number }) => {
  return <div children={children} className="container !px-2 md:px-[30px]" style={{ maxWidth: maxW }} />
}
